:root{
    .ti-product-notifications-dialog-content{
        line-height: $polaris-line-height-2;
        color: $pl-text-color-primary;
    }
}
